import { Zap, ChevronRight } from "lucide-react";

export function LiveLeadsFeed({ clues, running, onOpenEvidence }) {
  const list = clues || [];
  return (
    <div data-testid="live-leads-feed" className="bg-monk-panel border border-white/10 rounded-md overflow-hidden mb-6">
      <div className="px-4 py-3 border-b border-white/10 flex items-center gap-2">
        <Zap className="w-4 h-4 text-monk-blue" />
        <span className="overline">Live Leads · Clue Stream</span>
        {running && (
          <span className="ml-auto flex items-center gap-1.5 text-[10px] font-mono text-monk-blue" data-testid="clue-stream-live">
            <span className="w-1.5 h-1.5 rounded-full bg-monk-blue animate-pulse" /> LIVE
          </span>
        )}
      </div>
      <div className="max-h-[360px] overflow-auto divide-y divide-white/5">
        {list.length === 0 ? (
          <div className="p-6 text-center hunch-data text-[13px]">
            {running ? "Engines are working — clues will surface here the moment they emerge." : "No clues yet. Ingest evidence and Monk begins reasoning automatically."}
          </div>
        ) : (
          list.map((c) => (
            <button key={c.id} data-testid="clue-item"
              onClick={() => c.evidence_id && onOpenEvidence?.(c.evidence_id)}
              className={`w-full text-left px-4 py-2.5 transition-colors flex items-start gap-3 group ${c.cross_case ? "bg-amber-500/[0.06] border-l-2 border-amber-400/70" : ""} ${c.evidence_id ? "hover:bg-white/[0.03] cursor-pointer" : "cursor-default"}`}>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  {c.cross_case && <span className="text-[9px] font-mono px-1.5 py-0.5 rounded-sm border border-amber-400/40 text-amber-300 bg-amber-400/10" data-testid="cross-case-tag">CROSS-CASE</span>}
                  <span className={`text-[9px] font-mono px-1.5 py-0.5 rounded-sm border ${c.cross_case ? "border-amber-400/30 text-amber-200 bg-amber-400/5" : "border-monk-blue/30 text-monk-blue bg-monk-blue/10"}`}>{c.engine_label}</span>
                  <span className="text-[9px] font-mono text-neutral-600">{c.discipline}</span>
                  {typeof c.confidence === "number" && <span className="ml-auto text-[9px] font-mono text-neutral-500">{c.confidence}%</span>}
                </div>
                <p className="text-[13px] text-neutral-200 leading-snug line-clamp-2">{c.headline}</p>
                {c.evidence_label && <p className="text-[10px] font-mono text-neutral-600 mt-0.5 truncate">↳ {c.evidence_label}</p>}
              </div>
              {c.evidence_id && <ChevronRight className="w-4 h-4 text-neutral-700 group-hover:text-monk-blue shrink-0 mt-1 transition-colors" />}
            </button>
          ))
        )}
      </div>
    </div>
  );
}
